import {ContentResponse} from '$constants/api-infos'
import {
    CoverageContentParams,
    CoverageResponse,
    GetCoveragesRequest,
    InsurancePeerParams,
    PeerInsuranceResponse,
    UniCoverageResponse,
} from '$share/types/insurance'
import {externalInstance} from '$utils/api'
import {createTanstackQuery} from '$utils/createQuery'

export const getUniCoveragesQuery = createTanstackQuery<UniCoverageResponse>(() => ({
    url: '/insurance/coverages/uni/coverages',
    method: 'GET',
}))

export const getCoveragesQuery = createTanstackQuery<CoverageResponse, GetCoveragesRequest>((params) => ({
    url: '/insurance/coverages/list',
    method: 'GET',
    params,
}))

export const getInsurancePeerQuery = createTanstackQuery<PeerInsuranceResponse, InsurancePeerParams>((params) => ({
    url: '/insurance/coverages/peer',
    method: 'GET',
    params,
}))

export const getExternalInsurancePeerQuery = createTanstackQuery<PeerInsuranceResponse>(() => ({
    url: '/insurance/coverages/peer',
    method: 'GET',
    fetcher: externalInstance,
}))

export const getDetailConnectTipContentQuery = createTanstackQuery<ContentResponse | undefined, CoverageContentParams>(
    (params) => ({
        url: '/insurance/contents/coverages',
        method: 'GET',
        params,
        fetcher: externalInstance,
    }),
)
